"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroTabUnderline = exports.HeroTabText = exports.HeroTabNumber = exports.HeroTabList = exports.HeroTabIcon = exports.HeroTab = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireWildcard(require("react"));
var _spacing = require("../../constants/spacing");
var _fonts = require("../../fonts/fonts");
var _useTheme = require("../../theme/utils/useTheme");
var _Tab = require("./Tab");
var _TabList = require("./TabList");
var _TabUnderline = require("./TabUnderline");
var _TabsContext = require("./TabsContext");
var _heroTabsTheme = require("./heroTabsTheme");
var _tabsTheme = require("./tabsTheme");
const StyledHeroTabList = (0, _styled.default)(_TabList.TabList)`
    height: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _heroTabsTheme.heroTabsTheme.height(themeMode);
}};
    margin-bottom: ${_spacing.sizes.xLarge}px;
    white-space: initial;
    gap: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _heroTabsTheme.heroTabsTheme.gap(themeMode);
}};
`;
const HeroTabUnderline = (0, _styled.default)(_TabUnderline.TabUnderline)`
    height: 4px;
`;
exports.HeroTabUnderline = HeroTabUnderline;
const HeroTabList = _ref3 => {
  let {
    children,
    components = {},
    ...rest
  } = _ref3;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(StyledHeroTabList, (0, _extends2.default)({
    components: {
      ...components,
      TabUnderline: components.TabUnderline || HeroTabUnderline
    }
  }, rest, {
    themeMode: themeMode
  }), children);
};
exports.HeroTabList = HeroTabList;
const StyledHeroTab = (0, _styled.default)(_Tab.Tab)`
    padding-right: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _heroTabsTheme.heroTabsTheme.tabPaddingRight(themeMode);
}};
    margin-right: 0;
    height: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _heroTabsTheme.heroTabsTheme.height(themeMode);
}};
    display: flex;

    // Override default Tab styling.
    :not(:first-of-type) {
        margin-left: 0;
    }

    color: ${_ref6 => {
  let {
    themeMode,
    renderOn
  } = _ref6;
  return _tabsTheme.tabsTheme[renderOn].textColor(themeMode);
}};

    // If selected, the active tab will have tabindex = 0, other tabs will have tabindex=-1.
    &[tabindex="0"] {
        color: ${_ref7 => {
  let {
    themeMode
  } = _ref7;
  return _tabsTheme.tabsTheme.selectedTextColor(themeMode);
}};
    }

    &:focus::before {
        // Sync the bottom border with the thickness of the underline.
        border-bottom-width: 4px;
        // Pull the border away from the tab next to it, otherwise it overlaps the tab's number.
        right: ${_ref8 => {
  let {
    themeMode
  } = _ref8;
  return _heroTabsTheme.heroTabsTheme.borderRight(themeMode);
}};
    }
`;
const HeroTab = /*#__PURE__*/(0, _react.forwardRef)((_ref9, ref) => {
  let {
    children,
    ...rest
  } = _ref9;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    renderOn
  } = (0, _TabsContext.useTabsContext)();
  return /*#__PURE__*/_react.default.createElement(StyledHeroTab, (0, _extends2.default)({
    themeMode: themeMode,
    renderOn: renderOn
  }, rest, {
    ref: ref
  }), children);
});
exports.HeroTab = HeroTab;
HeroTab.displayName = "HeroTab";
/**
 * Used to show loading and error states in the Tab.
 * Either show this OR a HeroTabNumber.
 */
const HeroTabIcon = (0, _styled.default)(_lodestarIcons.Icon)`
    align-self: center;
    margin-bottom: 8px;
`;

/**
 * Used to show counts.
 * Either show this OR a HeroTabIcon.
 */
exports.HeroTabIcon = HeroTabIcon;
const StyledHeroTabNumber = (0, _styled.default)("div")`
    font-size: ${_ref10 => {
  let {
    themeMode
  } = _ref10;
  return _heroTabsTheme.heroTabsTheme.numberFontSize(themeMode);
}};
    line-height: ${_ref11 => {
  let {
    themeMode
  } = _ref11;
  return _heroTabsTheme.heroTabsTheme.numberLineHeight(themeMode);
}};
    font-weight: ${_ref12 => {
  let {
    themeMode
  } = _ref12;
  return _heroTabsTheme.heroTabsTheme.numberFontWeight(themeMode);
}};
    font-family: ${_fonts.ttNormsFontFamily};
    @supports (font-variation-settings: normal) {
        font-family: ${_fonts.ttNormsVarFontFamily};
    }
`;
const HeroTabNumber = /*#__PURE__*/(0, _react.forwardRef)((_ref13, ref) => {
  let {
    children,
    ...rest
  } = _ref13;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(StyledHeroTabNumber, (0, _extends2.default)({
    themeMode: themeMode
  }, rest, {
    ref: ref
  }), children);
});
exports.HeroTabNumber = HeroTabNumber;
HeroTabNumber.displayName = "HeroTabNumber";

/**
 * Used for the text labels next to the counts.
 */
const StyledHeroTabText = (0, _styled.default)("div")`
    font-size: ${_ref14 => {
  let {
    themeMode
  } = _ref14;
  return _heroTabsTheme.heroTabsTheme.textFontSize(themeMode);
}};
    font-weight: ${_ref15 => {
  let {
    themeMode
  } = _ref15;
  return _heroTabsTheme.heroTabsTheme.fontWeight(themeMode);
}};
    text-align: left;
    white-space: pre-line;
    margin-left: ${_ref16 => {
  let {
    themeMode
  } = _ref16;
  return _heroTabsTheme.heroTabsTheme.textMarginLeft(themeMode);
}};
    line-height: ${_ref17 => {
  let {
    themeMode
  } = _ref17;
  return _heroTabsTheme.heroTabsTheme.textLineHeight(themeMode);
}};
    margin-top: ${_ref18 => {
  let {
    themeMode
  } = _ref18;
  return _heroTabsTheme.heroTabsTheme.textMarginTop(themeMode);
}};
    margin-bottom: ${_ref19 => {
  let {
    themeMode
  } = _ref19;
  return _heroTabsTheme.heroTabsTheme.textMarginBottom(themeMode);
}};
    margin-right: 0;
    font-family: ${_fonts.ttNormsFontFamily};
    @supports (font-variation-settings: normal) {
        font-family: ${_fonts.ttNormsVarFontFamily};
    }
`;
const HeroTabText = /*#__PURE__*/(0, _react.forwardRef)((_ref20, ref) => {
  let {
    children,
    ...rest
  } = _ref20;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(StyledHeroTabText, (0, _extends2.default)({
    themeMode: themeMode
  }, rest, {
    ref: ref
  }), children);
});
exports.HeroTabText = HeroTabText;
HeroTabText.displayName = "HeroTabText";
//# sourceMappingURL=HeroTabs.js.map